module.exports = "//cdn.mxpnl.com/static/asset-cache/1267e72dbaad7449b08852aed0479a60/iron/common/assets/images/charts/rolling-stacked-line.svg";